import script from "./UserBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBookings.vue?vue&type=script&setup=true&lang=js"

import "./UserBookings.vue?vue&type=style&index=0&id=8d811876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d811876"]])

export default __exports__